export const env = {
    VUE_APP_API_URL: process.env.VUE_APP_API_URL || "__VUE_APP_API_URL__",
}
